import { DatePipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { CommandProgress, MdmCommand } from '@rocksoft/mdm-sdk-v2';
import { TimelineCommandContainerComponent } from '../timeline.command/timeline.command.container';

@Component({
  selector: 'ml-timeline-item',
  templateUrl: './timeline.item.component.html',
  imports: [FaIconComponent, TimelineCommandContainerComponent, DatePipe],
})
export class TimelineItemComponent {
  readonly commandProgress = input.required<CommandProgress>();
  readonly commandContent = input.required<MdmCommand>();

  readonly commandContentRequest = output<{
    udid: string;
    commandUUID: string;
  }>();

  isOpened: boolean;

  toggleIsOpened() {
    this.isOpened = !this.isOpened;
    if (this.commandContent() == undefined && this.isOpened) {
      const progress = this.commandProgress();
      const udid = progress.udid;
      const commandUUID = progress.commandUUID;
      if (!udid || !commandUUID) {
        return;
      }
      this.commandContentRequest.emit({ udid, commandUUID });
    }
  }
}
